import React from 'react'

const Sec1 = () => {
  return (
    <div className='section1'>
      <div className='career-sec1'>
        <div className='container'>
          <div className='row'>
            <div className='col-xl-6 left'>
              <p>
                Why work at <br />
                <span>Rean</span>?
              </p>
            </div>
            <div className='col-xl-4 offset-xl-1 right'>
              <p>
                At Rean you can explore a map full of exciting avenues for a
                whole new path. We entrust people with responsibilities early in
                their career and back them in taking calculated decisions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Sec1
